export const navDropdownData = [
    {
        text: "All services",
        linksData : [
            {
                text: "Service One",
                href: "/service-one"
            },
            {
                text: "Service Two",
                href: "/service-two"
            }
        ]
    }
];


export const navLinks = {
    links : [
        {
            text: "About us",
            href: "/about"
        },
        {
            text: "Case studies",  
            href: "/case-studies"
        },
        {
            text: "Blog",
            href: "/blog"
        }
    ],

    // buttons: [
    //     {
    //         text: "Get in touch",  
    //         href: "/contact"
    //     }
    // ]
};
